import {findIndex, isInteger} from 'lodash';
import emailPreviewService from '../../services/emailPreviewService';

const state = {
  preview: null,
  result: null,
  results: [],
  showingResultDialog: false,
  teamStats: null,
}

const mutations = {
  setPreview(state, preview) {
    state.preview = preview;
  },
  setResult(state, result) {
    state.result = result;
  },
  setResults(state, results) {
    state.results = results;
  },
  setShowingResultDialog(state, showingResultDialog) {
    state.showingResultDialog = showingResultDialog;
  },
  setTeamStats(state, teamStats) {
    state.teamStats = teamStats;
  }
}

const getters = {
  preview: state => state.preview,
  result: state => state.result,
  results: state => state.results,
  showingResultDialog: state => state.showingResultDialog,
  teamStats: state => state.teamStats,
  resultIndex: (state, getters) => {
    if (getters.result) {
      return findIndex(getters.results, r => r.id === getters.result.id);
    }
    return null;
  },
  hasPreviousResult: (state, getters) => {
    return isInteger(getters.resultIndex)
      && getters.resultIndex > 0;
  },
  getPreviousResult: (state, getters) => {
    if (getters.hasPreviousResult) {
      const index = findIndex(getters.results, r => r.id === getters.result.id);
      return getters.results[index - 1];
    }
    return null;
  },
  hasNextResult: (state, getters) => {
    return isInteger(getters.resultIndex)
      && getters.resultIndex < (getters.results.length - 1);
  },
  getNextResult: (state, getters) => {
    if (getters.hasNextResult) {
      const index = findIndex(getters.results, r => r.id === getters.result.id);
      return getters.results[index + 1];
    }
    return null;
  }
}

const actions = {
  setPreview({commit}, preview) {
    commit('setPreview', preview);
  },
  setResult({commit}, result) {
    commit('setResult', result);
  },
  setResults({commit}, results) {
    commit('setResults', results);
  },
  clearResult({commit}) {
    commit('setResult', null);
    commit('showingResultDialog', false);
  },
  setShowingResultDialog({commit}, showingResultDialog) {
    commit('setShowingResultDialog', showingResultDialog);
  },
  goPrevious({commit, getters}) {
    if (getters.hasPreviousResult) {
      commit('setResult', getters.getPreviousResult);
    }
  },
  goNext({commit, getters}) {
    if (getters.hasNextResult) {
      commit('setResult', getters.getNextResult);
    }
  },
  fetchTeamStats({commit}) {
    emailPreviewService.getTeamStats()
      .then(data => {
        commit('setTeamStats', data);
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
